export default import.meta.ROLLUP_FILE_URL_UbWiFH0l;